import { useState, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { AppConstant } from "../constant/AppConstant";
import { isLoginUser, openUrl, showLog, } from "../helper/utility";
import { SocialMediaLinkModel } from "../models/SocialMediaLinkModel";
import { SuburbModel } from "../models/SuburbModel";
import { ROUTES } from "../routes/Routes";
import downArrow from "../assets/icons/down_arrow.svg";
import CustomCartIcon from "../components/CustomCartIcon";
import { getLocalStorage, removeItemLocalStorage, setLocalStorage } from "../helper/localStorageHelper";
import { CustomFormInput } from "../components/CustomFormInput";
import { showSuccessAlert } from '../helper/alertHelper';
import logo from "../assets/icons/logo.png";
import menuIcon from "../assets/icons/menu.svg";
import closeIcon from "../assets/icons/close.svg";
import searchIcon from "../assets/icons/search.svg";
import locationIcon from "../assets/icons/selected_location.svg";
import TrackOrderDialog from './TrackOrderDialog';
import "../assets/css/Header.css";
import { updateExistingCart } from '../pages/cart/CartMangement';

interface HeaderProps {
    suburbs: SuburbModel[];
    socialMediaLink: SocialMediaLinkModel[];
    navigate: any;
    register: any;
    mobileMenuOpen: boolean;
    setMobileMenuOpen: (open: boolean) => void;
    setActiveMenu: (index: number | null) => void;
}

const TopHeader = ({
    suburbs,
    socialMediaLink,
    navigate,
    register,
    mobileMenuOpen,
    setMobileMenuOpen,
    setActiveMenu
}: HeaderProps) => {
    const location = useLocation();
    const shouldHideCart = [
        ROUTES.CART_PAGE.path,
        ROUTES.CHECKOUT.path,
        ROUTES.THANK_YOU.path.split("/:")[0],
    ].some((path) => location.pathname.startsWith(path));
    const [cartCount, setCartCount] = useState(0);
    const cartIconRef = useRef<HTMLDivElement | null>(null);
    const [showFloatingCart, setShowFloatingCart] = useState(false);
    const [showLoginDropdown, setShowLoginDropdown] = useState(false);
    const [filteredSuburbs, setFilteredSuburbs] = useState<SuburbModel[]>([]);
    const storedSuburb = getLocalStorage(AppConstant.userSelectedSuburb);
    const initialSuburb =
        storedSuburb && storedSuburb !== "null" && storedSuburb !== "undefined"
            ? storedSuburb
            : "";
    const [searchTerm, setSearchTerm] = useState(initialSuburb);
    const [selectedLocation, setSelectedLocation] = useState(initialSuburb);
    const loginRef = useRef<HTMLDivElement | null>(null);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
        setActiveMenu(null);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (loginRef.current && !loginRef.current.contains(event.target as Node)) {
                setShowLoginDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSearchSuburb = async (searchValue: string, item: SuburbModel) => {
        const selectedCity = item?.city_id;
        setLocalStorage(AppConstant.userSelectedStateId, item.state_id);
        setLocalStorage(AppConstant.userSelectedCityId, selectedCity);
        setLocalStorage(AppConstant.userSelectedSuburbId, item._id);
        setLocalStorage(AppConstant.userSelectedSuburb, searchValue);
        setLocalStorage(AppConstant.userSelectedSuburbPrices, JSON.stringify(item.selected_city));
        setLocalStorage(AppConstant.locationPopupShow, false);
        showSuccessAlert("Ground location Secured!");
        setSelectedLocation(searchValue);
        updateExistingCart(item.selected_city);
        setTimeout(() => {
            window.location.reload();
        }, 800);
    };

    const handleInputChange = (value: string) => {
        setSearchTerm(value);

        if (value.trim().length < 2) {
            setFilteredSuburbs([]);
            return;
        }

        const filtered = suburbs.filter((suburb) => {
            return (
                suburb.name?.toLowerCase().includes(value.toLowerCase()) ||
                //suburb.state_name?.toLowerCase().includes(value.toLowerCase()) ||
                //suburb.city_name?.toLowerCase().includes(value.toLowerCase()) ||
                suburb.postal_code?.toLowerCase().includes(value.toLowerCase())
            );
        });

        setFilteredSuburbs(filtered);
    };

    useEffect(() => {
        if (!cartIconRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    setShowFloatingCart(!entry.isIntersecting);
                });
            },
            { threshold: 0.1 }
        );

        observer.observe(cartIconRef.current);

        return () => observer.disconnect();
    }, []);

    const handleCartClick = () => {
        navigate(ROUTES.CART_PAGE.path);
    }

    useEffect(() => {
        const updateLocation = () => {
            const stored = getLocalStorage(AppConstant.userSelectedSuburb) || "";
            const selectedCityStr = getLocalStorage(AppConstant.userSelectedSuburbPrices);
            const selected_city = selectedCityStr
                ? JSON.parse(selectedCityStr)
                : null;

            setSelectedLocation(stored);
            setSearchTerm(stored);

            if (selected_city) {
                updateExistingCart(selected_city);
            }
        };

        updateLocation();

        window.addEventListener(AppConstant.localStorageUpdated, updateLocation);

        window.addEventListener("storage", updateLocation);

        return () => {
            window.removeEventListener(AppConstant.localStorageUpdated, updateLocation);
            window.removeEventListener("storage", updateLocation);
        };
    }, []);

    return (
        <>
            <div className="header-top">
                <div className="header-top-content">
                    <div className="custom-marquee header-top-left">
                        <p className="header-top-title">
                            Mobile fitting available in Queensland and New South Wales. Store is available in Brisbane Queensland.
                        </p>
                    </div>
                    <div
                        className='header-top-right-track'
                    >
                        <div className="header-top-right">
                            <h5>ABN : 19652270187</h5>
                            {socialMediaLink.map((item) => (
                                <img
                                    key={item._id}
                                    src={`${AppConstant.IMAGE_BASE_URL}${item.icon_image}`}
                                    width={24}
                                    alt={item.title}
                                    onClick={() => openUrl(item.social_media_url, true)}
                                />
                            ))}
                        </div>
                        <div className="header-top-track" onClick={() => { TrackOrderDialog.show() }}>
                            <h5>Track Order</h5>
                            <img src={locationIcon} alt="location" />
                        </div>
                    </div>

                </div>
            </div>

            <div className="header-middle">
                <div className="header-middle-content">
                    <div className='header-middle-menu'>
                        <img className="header-middle-menu-icon"
                            src={menuIcon}
                            alt="menuIcon"
                            onClick={toggleMobileMenu}
                        />
                        <img className="header-middle-logo"
                            src={logo}
                            alt="Logo"
                            onClick={() => openUrl(ROUTES.HOME.path)}
                        />
                    </div>

                    <div className="header-middle-search">
                        <div className='header-middle-search-wrapper'>
                            <CustomFormInput
                                label=""
                                {...(selectedLocation !== "" ? { value: selectedLocation } : {})}
                                //value={selectedLocation && selectedLocation !== "undefined" ? selectedLocation : searchTerm}
                                {...(selectedLocation && selectedLocation !== "undefined" ? { value: selectedLocation } : {})}
                                controlId="header_search_suburb"
                                placeholder="Enter suburb & click search icon"
                                register={register}
                                onChange={(value) => {
                                    handleInputChange(value);
                                }}
                                border="none"
                                borderRadius={0}
                                asCol={false}
                                fullWidth={true}
                            />

                            {((selectedLocation && selectedLocation.trim() !== "" && selectedLocation.trim() !== "undefine")) ? (
                                <img
                                    src={closeIcon}
                                    alt="close"
                                    className="header-middle-search-icon"
                                    onClick={() => {
                                        setSearchTerm("");
                                        setSelectedLocation("");
                                        removeItemLocalStorage(AppConstant.userSelectedCityId);
                                        removeItemLocalStorage(AppConstant.userSelectedSuburb);
                                        removeItemLocalStorage(AppConstant.locationPopupShow);
                                        window.location.reload();
                                    }}
                                />
                            ) : (
                                <img
                                    src={searchIcon}
                                    alt="search"
                                    className="header-middle-search-icon"
                                />
                            )}
                        </div>
                        {filteredSuburbs.length > 0 && (
                            <ul className='header-middle-search-dropdown'>
                                {filteredSuburbs.map((item, index) => (
                                    <li className='header-middle-search-dropdown-item'
                                        key={index}
                                        onClick={() => {
                                            const formatted = `${item.name}, ${item.state_name}, ${item.postal_code}`;
                                            setSearchTerm(formatted);
                                            setFilteredSuburbs([]);
                                            handleSearchSuburb(formatted, item);
                                        }}>
                                        <span className="header-middle-location-icon" />

                                        {`${item.name}, ${item.state_name}, ${item.postal_code}`}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <div className="header-middle-right" ref={loginRef}>
                        <CustomCartIcon
                            cartRef={cartIconRef}
                            onClick={handleCartClick}
                            itemCount={cartCount}
                            setItemCount={setCartCount} />

                        <div className="header-middle-account-wrapper"
                            onClick={() => setShowLoginDropdown((prev) => !prev)}>
                            <div className="header-middle-account" onClick={() => isLoginUser() && navigate(ROUTES.MY_ACCOUNT.path)}>
                                <span>My Account</span>
                                <img src={downArrow} alt="downArrow" />
                            </div>

                            <span className="header-middle-name">
                                Hello, {isLoginUser() ? getLocalStorage(AppConstant.userName) : "Sign in"}
                            </span>

                            {!isLoginUser() && showLoginDropdown && (
                                <div className="header-middle-login-dialog">
                                    <p className="header-middle-login-dialog-title">Sign up now and enjoy shopping</p>
                                    <button
                                        className="custom-primary-button"
                                        onClick={() => navigate(ROUTES.SIGN_IN.path)}
                                    >
                                        Sign In
                                    </button>
                                    <p className="header-middle-login-dialog-signup">
                                        New Customer?{" "}
                                        <span onClick={() => navigate(ROUTES.SIGN_UP.path)}>Sign Up</span>
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>

            {(showFloatingCart && cartCount > 0 && !shouldHideCart) && (
                <div
                    className="floating-cart-icon"
                    onClick={handleCartClick}
                >
                    <CustomCartIcon
                        itemCount={cartCount}
                        setItemCount={setCartCount}
                    />
                </div>
            )}

        </>
    );
};

export default TopHeader;
